// extracted by mini-css-extract-plugin
export default {"wrap":"StarRate_wrap__VOP-a","star_icon":"StarRate_star_icon__UsWGi"};